<template>
    <!-- contents -->
    <router-view></router-view>
    <!-- //contents -->
</template>

<script>
export default {
    name: 'KnowledgeManagerMain'

};
</script>

<style></style>



// WEBPACK FOOTER //
// src/skpComponents/view/admin/knowledgeManager/KnowledgeManagerMain.vue